import React from "react";
import { useLocation, useNavigate,  Outlet } from "react-router-dom";
import {
  TbBookUpload,
  TbTextScan2,
} from "react-icons/tb";
import { RiExchangeFundsLine } from "react-icons/ri";
import { LuUserSquare2 } from "react-icons/lu";
import { ContentLayout,ContentWrapper,ContentMenu,ContentForm, ContentHeading, } from "../../style";
import { List, ListIcon, ListItem, ListText } from "../../../ppui/list";
import { EmployeeContextProvider } from "../../../context/employee-context";
import { Typography } from "../../../ppui";

function AdminSettings() {
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = [
    {
      icon: <TbTextScan2 />,
      primaryText: "Allowance Data",
      path: "",
    },
    // {
    //   icon: <TbCalendarExclamation />,
    //   primaryText: "Holiday",
    //   path: "settings/holiday-management",
    // },
    {
      icon: <TbBookUpload />,
      primaryText: "P-Tax",
      path: "p-tax",
    },
    {
      icon: <RiExchangeFundsLine />,
      primaryText: "Labour Welfare Fund",
      path: "labour-welfare-fund",
    },
    {
      icon: <LuUserSquare2 />,
      primaryText: "ESI Contribution",
      path: "esi-contribution",
    },
    {
      icon: <LuUserSquare2 />,
      primaryText: "Leave Management",
      path: "leave-management",
    },
  ];

  return (
    <>
      <EmployeeContextProvider>
        <ContentLayout>
          <ContentHeading>
            <Typography variant="h5" mb="0">
              Settings
            </Typography>
          </ContentHeading>
          <ContentWrapper>
            <ContentMenu>
              <List
                size={"md"}
                color={"default"}
                activeColor={"success"}
                Colorvariant={"dark"}
                hover={"secondary"}
                gap={15}
              >
                {menuItems.map((item, index) => (
                  <ListItem
                    key={index}
                    onClick={() => navigate(item.path)}
                    className={location.pathname === item.path ? "active" : ""}
                  >
                    <ListIcon>{item.icon}</ListIcon>
                    <ListText primary={item.primaryText} />
                  </ListItem>
                ))}
              </List>
            </ContentMenu>
            <ContentForm>
              <Outlet />
            </ContentForm>
          </ContentWrapper>
        </ContentLayout>
      </EmployeeContextProvider>
    </>
  );
}

export default AdminSettings;
